export * from "./admins";
export * from "./members";
export * from "./deposits";
export * from "./points";
export * from "./cashes";
export * from "./levels";

import codes from "./codes";
import * as ebookCompanies from "./ebook-companies";
import * as terms from "./terms";
import * as viewers from "./viewers";
import * as integratedViewers from "./integrated-viewers";
import * as apiKeys from "./api-keys";

export const user = {
    codes,
    ...ebookCompanies,
    ...terms,
    ...viewers,
    ...integratedViewers,
    ...apiKeys,
};
